import { FC, memo, useCallback, useEffect, useRef, useState } from 'react'
import styles from './header-bottom.module.scss'
import Logotype from '@/components/ui/Logotype'
import HeaderNavMenu from './HeaderNavMenu'
import PhoneNumber from '@/components/ui/PhoneNumber'
import LoginButton from '@/components/ui/LoginButton'
import RegisterButton from '@/components/ui/RegisterButton'
import BalanceButton from '@/components/ui/BalanceButton'
import ThemeSwitch from '@/components/features/ThemeSwitch'
import LangController from '@/components/features/LangController'
import classNames from '@/utils/helpers/class-names.helper'
import Link from 'next/link'
import useI18nPath from '@/hooks/i18n-path.hook'

type HeaderBottomProps = {
  onCloseBurgerMenu: () => void
  visibleBurgerMenu: boolean
}

const HeaderBottom: FC<HeaderBottomProps> = ({ onCloseBurgerMenu, visibleBurgerMenu }) => {
  const ref = useRef<HTMLDivElement>(null)
  const { getHrefLang } = useI18nPath()

  const [scrollVisible, setScrollVisible] = useState<boolean>(true)
  const lastScrollYRef = useRef(0)

  const handleClickOutside = useCallback(
    (e: MouseEvent) => {
      if (!ref?.current?.contains(e.target as Node)) {
        onCloseBurgerMenu()
      }
    },
    [onCloseBurgerMenu]
  )

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [handleClickOutside])

  const controlHeader = useCallback(() => {
    if (typeof window !== 'undefined') {
      const currentScrollY = window.scrollY

      setScrollVisible((prevVisible) => {
        if (currentScrollY < 100) return true
        if (currentScrollY < lastScrollYRef.current) {
          return true
        } else if (currentScrollY > lastScrollYRef.current) {
          if (Math.abs(currentScrollY - lastScrollYRef.current) > 20) {
            return false
          }
        }
        return prevVisible
      })

      lastScrollYRef.current = currentScrollY
    }
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', controlHeader)

    return () => {
      window.removeEventListener('scroll', controlHeader)
    }
  }, [controlHeader])

  return (
    <div
      ref={ref}
      className={classNames(
        styles.header__bottom,
        visibleBurgerMenu && '_visible',
        !scrollVisible && styles['_scroll-hidden']
      )}
    >
      <div className={classNames('container', styles.sticky)}>
        <div className={styles.inner}>
          <Link href={getHrefLang('/')} aria-label="Главная">
            <Logotype className={styles.logo} subText="Нам 25 лет!" capa />
          </Link>
          <HeaderNavMenu />

          <div className={styles.account}>
            <LoginButton className={styles.login} />
            <RegisterButton className={styles.registration} />
          </div>

          <div className={styles.options}>
            <BalanceButton />
            <ThemeSwitch />
            <LangController />
          </div>

          <PhoneNumber />
        </div>
      </div>
    </div>
  )
}

export default memo(HeaderBottom)
